import { Component } from 'vue-property-decorator';
import Base from '@/components/Base';
import { VerifyEmailCard } from '@streamlabs-core/sl-one-fe-components-vue2';
import feSdk from '@streamlabs-core/sl-one-fe-sdk';
import { EAnalyticsEvent } from '@/helpers/analytic';

@Component({
  components: {
    VerifyEmailCard,
  },
})
export default class SLVerifyEmailForm extends Base {
  intent = 'connect';

  get defaultContext() {
    return {
      email: this.slidModule?.session?.email,
      tfa: ''
    };
  }

  async handleVerifySuccess() {
    try {
      await this.startDirectConnect();
      return true;
    } catch (err) {
      // do nothing
      if (!this.handleVerificationError(err)) {
        this.onRedirectRequested('login');
      }

      return false;
    }
  }

  async startDirectConnect() {
    const { redirect_url } = await feSdk.api.identity.connectIdentity({
      origin: window.location.origin,
      pk: feSdk.env.get().services.identity.pk,
      intent: this.intent,
      state: btoa(JSON.stringify({ r: '/projects' })),
    });

    this.$sla.sendEvent(EAnalyticsEvent.slNativeLoginSuccess);
    window.location.href = redirect_url;
  }

  onRedirectRequested(to: string) {
    if (to === 'login')
      this.$router.push('/login');

    if (to === 'tfa')
      this.$router.push('/verify-tfa');
  }

  onBackRequested() {
    this.onRedirectRequested('login');
  }

  handleVerificationError(error) {
    if (error.data?.code === 'email_verification_required') {
      this.$router.push('/login');
    } else if (error.data?.code === 'token_required') {
      this.$router.push('/tfa');
    } else if (error.data?.code === 'age_gate_required') {
      this.$router.push('/age-gating');
    } else {
      return false;
    }
  };
}


